import Application from "../../Application";
import { UserPreferences } from "../../common/Constants";
import PortalHomePresenter, {
  IPortalHomePresenter
} from "../../presenter/portal/PortalHomePresenter";
import { INoticeService } from "../../service/notice/NoticeService";

export default class ShowPortalHomeInteractor {
  private application: Application;
  private output?: IPortalHomePresenter;
  private noticeService: INoticeService;

  constructor(application, noticeService) {
    this.application = application;
    this.noticeService = noticeService;
  }

  execute() {
    this.output = PortalHomePresenter({
      application: this.application,
      initialState: {
        noticeList: []
      }
    });
    const selectedLanguage =
      this.application.container.resolve("language") ??
      UserPreferences.DEFAULT_LANGUAGE;
    this.noticeService
      .getNoticeList(`${selectedLanguage}`)
      .then(this.output && this.output.loadNoticeList);

    return this.output;
  }
}
